module.exports = __webpack_public_path__ + "img/cardFrame_S_3.a76ee698.png";